import { defineMessages } from 'react-intl'

export default defineMessages({
  contentLoadError: {
    id: 'app.status.contentLoadError',
    defaultMessage: 'There was a problem loading this content',
  },
  listLoadError: {
    id: 'app.status.listLoadError',
    defaultMessage: 'There was a problem loading this list',
  },

  unsupportedRegion: {
    id: 'app.errors.unsupportedRegion',
    defaultMessage: 'Our service is not available in your region at this time.',
  },
  supportedRegions: {
    id: 'app.errors.supportedRegions',
    defaultMessage:
      "Flix Premiere is currently available in the USA and UK. If you can't access our content from these territories please contact us at support@flixpremiere.com",
  },
})
